import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

// Self-hosted fonts (bundled by Vite as same-origin assets) — no external
// Google Fonts dependency, so the tight CSP holds and the PWA shell works
// offline. Variable packages register as '<Name> Variable'; Amiri is static.
import '@fontsource-variable/fraunces/opsz.css';
import '@fontsource-variable/manrope/index.css';
import '@fontsource-variable/jetbrains-mono/index.css';
import '@fontsource-variable/cairo/index.css';
import '@fontsource/amiri/index.css';

import App from './App';
import './i18n';
import './index.css';

createRoot(document.getElementById('root')!).render(
    <StrictMode>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </StrictMode>,
);
